// extracted by mini-css-extract-plugin
export var bubble = "_1h-0";
export var container = "_1h-f";
export var contrastBorder = "_1h-g";
export var greyOut = "_1h-2";
export var initialsColor0 = "_1h-3";
export var initialsColor1 = "_1h-4";
export var initialsColor10 = "_1h-d";
export var initialsColor11 = "_1h-e";
export var initialsColor2 = "_1h-5";
export var initialsColor3 = "_1h-6";
export var initialsColor4 = "_1h-7";
export var initialsColor5 = "_1h-8";
export var initialsColor6 = "_1h-9";
export var initialsColor7 = "_1h-a";
export var initialsColor8 = "_1h-b";
export var initialsColor9 = "_1h-c";
export var initialsWrapper = "_1h-1";
export var large = "_1h-l";
export var medium = "_1h-k";
export var mediumSmall = "_1h-j";
export var mediumSmallMedium = "_1h-o";
export var micro = "_1h-h";
export var small = "_1h-i";
export var tiny = "_1h-n";
export var xTiny = "_1h-m";